export const optimoveSetPageVisit = (pageCategory: string) => {
  if (typeof window === 'undefined' || !window.optimoveSDKEnabled) return;
  const { origin, pathname } = window.location;
  window.optimoveSDK.API.setPageVisit(origin + pathname, pageCategory);
};
